import React from 'react';
import './Xpart.css';

const Xppart = () => {
    return (
        <section className='mt-5 pt-5  bg-dark bg-opacity-50 headingrespo overflow-hidden'>
            <div className='container'>
                <div className='container d-flex justify-content-center align-items-center ms-5 ps-5 respoMargin'>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/NFkBf0d/html-5.png" alt="html" className=' forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/mzL7n64/css.png" alt="css" className='forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/p3nhD4W/js.png" alt="js" className='forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/fD4ZXcH/physics.png" alt="react" className=' forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/jhkc8bC/nodejs.png" alt="node" className=' forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/pXg0Lmg/figma.png" alt="figma" className='img-fluid forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/qr57mbF/bootstrap.png" alt="bootstrap" className='img-fluid forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/CBH7xbv/database.png" alt="database" className='img-fluid forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/8Yg233Q/download.png" alt="firebase" className='img-fluid forRespowidth2' style={{ width: '45px' }} />
                    </div>
                    <div className='me-5 pt-3 pb-5 forRespowidth'>
                        <img src="https://i.ibb.co/hggTf9L/download-1.png" alt="unknown" className='img-fluid forRespowidth2' style={{ width: '45px' }} />
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Xppart;